import { ApiRoutes } from '@gr/core/api-routes';
import type { MediaDetailsDto, MediaDto, MediaListQuery, MediaTrafficDto, UploadMediaResponseDto } from '@gr/core/content/media/dto';
import type { MediaStorageDto, RecompressParamsDto } from '@gr/core/content/media/recompress';
import type { TaskDto } from '@gr/core/platform/tasks/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient, UploadProgress } from '../../../shared/http/http-client';

export class MediaApi {
  constructor(private readonly http: HttpClient) {}

  list(blogId: string, query: MediaListQuery = {}): Promise<OperationResult<MediaDto[]>> {
    return this.http.get(ApiRoutes.media.list(blogId), { ...query });
  }
  get(blogId: string, mediaId: string): Promise<OperationResult<MediaDetailsDto>> {
    return this.http.get(ApiRoutes.media.byId(blogId, mediaId));
  }
  upload(blogId: string, file: File, onProgress?: (progress: UploadProgress) => void): Promise<OperationResult<UploadMediaResponseDto>> {
    return this.http.upload(ApiRoutes.media.list(blogId), file, onProgress);
  }
  updateNote(blogId: string, mediaId: string, note: string): Promise<OperationResult<MediaDetailsDto>> {
    return this.http.patch(ApiRoutes.media.byId(blogId, mediaId), { note });
  }
  delete(blogId: string, mediaId: string): Promise<OperationResult<{ id: string; title: string }[] | null>> {
    return this.http.delete(ApiRoutes.media.byId(blogId, mediaId));
  }
  traffic(blogId: string): Promise<OperationResult<MediaTrafficDto>> {
    return this.http.get(ApiRoutes.media.traffic(blogId));
  }
  // MED-UC-8
  storage(blogId: string): Promise<OperationResult<MediaStorageDto>> {
    return this.http.get(ApiRoutes.media.storage(blogId));
  }
  // MED-UC-9
  recompress(blogId: string, params: RecompressParamsDto): Promise<OperationResult<TaskDto>> {
    return this.http.post(ApiRoutes.media.recompress(blogId), params);
  }
  thumbnailUrl(blogId: string, mediaId: string): string {
    return ApiRoutes.media.thumbnail(blogId, mediaId);
  }
  originalUrl(blogId: string, mediaId: string): string {
    return ApiRoutes.media.original(blogId, mediaId);
  }
  renditionUrl(blogId: string, mediaId: string): string {
    return ApiRoutes.media.rendition(blogId, mediaId);
  }
}
